import React from 'react';

export type SelectOption = {
  value: string;
  label: string;
};

type SelectProps = {
  label?: string;
  name?: string;
  options: SelectOption[];
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  helperText?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
};

export function Select({
  label,
  name,
  options,
  placeholder = 'Sélectionner',
  value,
  onChange,
  helperText,
  error,
  required,
  disabled,
  className = ''
}: SelectProps) {
  const selectClasses = `block w-full rounded-md border-gray-300 shadow-xs 
    focus:border-blue-500 focus:ring-blue-500 p-2
    ${error ? 'border-red-300' : ''} 
    ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
    ${className}`;

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <select
        className={selectClasses}
        name={name}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {helperText && (
        <p className="mt-1 text-sm text-gray-500">{helperText}</p>
      )}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
